import ServiceTemplate from '@/components/ServiceTemplate';

export default function BusinessFormation() {
  const data = {
    title: 'Business Formation Services',
    subtitle: 'Complete business formation for all entity types with expert guidance.',
    overviewTitle: 'Starting Your Business Right',
    overviewImage: 'https://images.unsplash.com/photo-1556761175-b413da4baf72',
    description: [
      'Choosing the right business structure is one of the most important decisions for new business owners. The structure affects liability protection, taxation, and operational flexibility.',
      'We guide you through selecting and forming the optimal business structure - LLC, Corporation, Partnership, or other entity type - based on your specific goals, industry, and growth plans.',
      'Our comprehensive formation service handles all filing requirements, obtains necessary licenses, and ensures your business starts with a strong legal and operational foundation.'
    ],
    benefits: [
      { title: 'Expert Guidance', description: 'Help selecting the right entity structure for your goals.' },
      { title: 'Complete Filing', description: 'Handle all state and federal filing requirements.' },
      { title: 'Legal Compliance', description: 'Ensure compliance with all applicable regulations.' },
      { title: 'Liability Protection', description: 'Establish proper liability protection for owners.' },
      { title: 'Tax Optimization', description: 'Structure for optimal tax treatment.' },
      { title: 'Ongoing Support', description: 'Continued guidance for business needs.' }
    ],
    process: [
      { title: 'Structure Selection & Planning', description: 'Evaluate your goals and recommend optimal entity type tailored to your business needs.' },
      { title: 'Name Registration & Documentation', description: 'Check business name availability, register with state, and complete all required formation documents.' },
      { title: 'Compliance & Licensing', description: 'Obtain EIN, required licenses, and establish ongoing compliance procedures.' }
    ],
    pricing: [
      {
        name: 'Basic',
        description: 'Essential formation',
        price: '$299',
        period: '+ state fees',
        features: [
          'Entity formation filing',
          'Name availability check',
          'EIN application',
          'Basic documents',
          'Email support',
          'Document delivery'
        ]
      },
      {
        name: 'Professional',
        description: 'Complete package',
        price: '$599',
        period: '+ state fees',
        featured: true,
        features: [
          'Everything in Basic',
          'Custom agreements',
          'Tax consultation',
          'Compliance setup',
          'Registered agent (1 year)',
          'Priority processing',
          'Phone support'
        ]
      },
      {
        name: 'Enterprise',
        description: 'Full-service solution',
        price: '$999',
        period: '+ state fees',
        features: [
          'Everything in Professional',
          'Multi-state filing',
          'Advanced structuring',
          'Annual compliance',
          'Quarterly reviews',
          'Dedicated attorney',
          'Unlimited consultations'
        ]
      }
    ],
    faqs: [
      { question: 'What business structure should I choose?', answer: 'Choice depends on liability needs, tax goals, ownership structure, and growth plans. We evaluate your situation to recommend the optimal structure.' },
      { question: 'How long does formation take?', answer: 'State processing times vary from 1-4 weeks, though expedited filing is available in most states.' },
      { question: 'What is an EIN?', answer: 'An Employer Identification Number (EIN) is a federal tax ID required for most businesses to open bank accounts, hire employees, and file taxes.' },
      { question: 'Do I need licenses to operate?', answer: 'Requirements vary by location and industry. We help identify required business licenses and registrations.' },
      { question: 'Can I change my business structure later?', answer: 'Yes, businesses can convert between structures, though tax implications should be carefully evaluated.' },
      { question: 'What ongoing requirements apply?', answer: 'Requirements typically include annual reports, tax filings, maintaining registered agent, and proper record-keeping.' },
      { question: 'Should I form in my state or Delaware?', answer: 'Most small businesses should form in their home state. Delaware incorporation has specific advantages for larger companies and those seeking venture capital.' },
      { question: 'What is a registered agent?', answer: 'A registered agent receives legal documents on behalf of your business. We can serve as your registered agent.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
